import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { isValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from './types.tsx';

const fetchTranslationSummaries =
	(projectId: number, analyticsEvent?: UIAnalyticsEvent, isForceSearch = false): Action<State> =>
	async ({ setState, getState }) => {
		const { loading, isDataInitialised } = getState();

		if (!isForceSearch && (loading || isDataInitialised)) {
			return;
		}

		setState({ loading: true });
		try {
			const { languageTranslationSummaries } = await fetchJson(
				`/rest/servicedesk/lingo-integration/1/manage-language/${projectId}/translation-summaries`,
			);

			setState({
				data: { languageTranslationSummaries },
				loading: false,
				isDataInitialised: true,
			});

			if (analyticsEvent) {
				fireOperationalAnalytics(analyticsEvent, 'translationSummaries fetched', {
					projectId,
				});
			}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({ error, loading: false });
			log.safeErrorWithoutCustomerData(
				'servicedesk.languages.services.translation-summaries',
				error.message,
				error,
			);
			trackFetchErrors({
				error,
				id: 'services.translation-summaries.fetch',
				packageName: 'jiraServicedeskLanguages',
				logToSentry: !isValidationError(error),
			});
		}
	};

export const actions = { fetchTranslationSummaries } as const;
export type Actions = typeof actions;
